'use strict';

var $ = require('jquery');

module.exports = function(el) {
    new LoadMoreFetcher(el, $(el).data());
};

var OPTIONS = {
    loadingText: 'Loading...',
    loadingClass: 'is-loading',
    loadTarget: 'body',
    loadFilterSelector: '',
    loadMoreButtonSelector: ''
};

function LoadMoreFetcher(el, opts) {
    this.$el = $(el);
    this.originalText = this.$el.text();
    this.opts = $.extend(OPTIONS, {
        loadMoreButtonSelector: this.$el.attr('id') ? '#' + this.$el.attr('id') : ''
    }, opts);
    this.state = {
        loading: false,
        enabled: true
    };

    this.addListeners();
}

LoadMoreFetcher.prototype.addListeners = function() {
    this.$el.on('click', this.loadNextPage.bind(this));
};

LoadMoreFetcher.prototype.doLoading = function() {
    this.state.loading = true;
    this.$el.text(this.opts.loadingText);
    this.$el.addClass(this.opts.loadingClass);
};

LoadMoreFetcher.prototype.doNotLoading = function() {
    this.state.loading = false;
    this.$el.text(this.originalText);
    this.$el.removeClass(this.opts.loadingClass);
};

LoadMoreFetcher.prototype.loadNextPage = function(e) {
    e.preventDefault();

    if (this.state.loading) return;

    this.doLoading();

    $.get(this.$el.attr('href'), this.handleResponse.bind(this));
};

LoadMoreFetcher.prototype.handleResponse = function(resp) {
    this.doNotLoading();

    var $src = $('' + resp + '');

    $(this.opts.loadTarget).append($src.find(this.opts.loadFilterSelector));

    var nextPageHref = $src.find(this.opts.loadMoreButtonSelector).attr('href');

    if (nextPageHref) {
        this.$el.attr('href', nextPageHref);
    } else {
        this.$el.remove();
    }
};



//////////////////
// WEBPACK FOOTER
// ./modules/loadMore.js
// module id = 4
// module chunks = 0